import { useState } from "react";
import Tabs from "@/components/Usados/Tabs";
import ListarRoles from "./rolesTab/listar";
import CrearRol from "./rolesTab/crear";

export default function RolesTab() {
  const [activeTab, setActiveTab] = useState("Listar");
  const [rolParaEditar, setRolParaEditar] = useState<any>(null);

  const handleEditar = (rol: any) => {
    setRolParaEditar(rol);
    setActiveTab("crear");
  };

  const handleFinalizado = () => {
    setRolParaEditar(null);
    setActiveTab("Listar");
  };

  const tabs = [
    {
      value: "Listar",
      label: "Lista de roles",
      content: <ListarRoles onEdit={handleEditar} />,
    },
    {
      value: "crear",
      label: rolParaEditar ? "Editar rol" : "Crear rol",
      content: (
        <CrearRol
          rol={rolParaEditar}
          onSuccess={handleFinalizado}
          onCancel={() => {
            setRolParaEditar(null);
            setActiveTab("Listar");
          }}
        />
      ),
    },
  ];

  return (
    <div className="space-y-6">
      <Tabs
        tabs={tabs}
        activeTab={activeTab}
        onTabChange={setActiveTab}
        activeTextClass="text-green-800"
        activeBorderClass="border-green-800"
        activeGlowClass="bg-green-800/40"
      />
    </div>
  );
}
